import React from 'react';
import PropTypes from 'prop-types';
import MuiBackdrop from '@mui/material/Backdrop';

const Backdrop = ({
    children,
    sx,
    inverted,
    open = false,
    'data-testid': dataTestId,
}) => {
    if (!open) return null;

    return (
        <MuiBackdrop
            open
            data-inverted={inverted}
            data-testid={dataTestId}
            sx={sx}
        >
            {children}
        </MuiBackdrop>
    );
};

Backdrop.propTypes = {
    children: PropTypes.node,
    sx: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array,
        PropTypes.func,
    ]),
    open: PropTypes.bool,
    inverted: PropTypes.bool,
    'data-testid': PropTypes.string,
};

export default Backdrop;
